import React, { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import { Button, Table, Input, Tooltip, Tag, Row, Col } from 'antd';
import {
  EyeOutlined,
  RedoOutlined,
  SecurityScanTwoTone,
  SyncOutlined,
  CheckCircleOutlined,
} from '@ant-design/icons';
const { Search } = Input;

// style
import UserLayoutStyle from './style.js';

// service
import { getListUser, getUserCount } from '../../services/user';

// Modal
import ModalPin from '../../components/Modals/ModalPin';

// components
import CustomBreadcrumb from '../../components/Breadcrumb';
import StatisticCard from '../../components/Cards/StatisticCard/index.jsx';

// import PropTypes from 'prop-types'
function UserPage() {
  const [listUser, setListUser] = useState({});
  const [isLoading, setLoading] = useState(false);
  const [pageTokens, setPageTokens] = useState([]);
  const [nextPageToken, setNextPageToken] = useState('');
  const [current, setCurrent] = useState(1);
  const [totalItem, setTotalItem] = useState(0);

  const [isShow, setIsShow] = useState(false);
  const [userId, setUserId] = useState('');
  const [userCount, setUserCount] = useState({});

  const [params, setParams] = useState({
    pageToken: '',
    limit: 10,
    phoneNumber: '',
  });

  useEffect(() => {
    const token = localStorage && localStorage.getItem('opentrace_token');
    if (token === null) {
      window.location.replace('/login');
    }
    getUserList(params);
  }, [params]);

  useEffect(() => {
    onGetUserCount();
  }, []);

  const routes = [
    {
      name: 'User Management',
    },
  ];

  const columns = [
    {
      title: 'Phone number',
      dataIndex: 'phoneNumber',
      key: 'phone',
    },
    {
      title: 'Last sign in',
      dataIndex: 'lastSignInTime',
      key: 'lastSignInTime',
    },
    {
      title: 'Created at',
      dataIndex: 'createdAt',
      key: 'createdAt',
    },
    {
      title: 'Verification code',
      dataIndex: 'uid',
      key: 'uid',
      // eslint-disable-next-line react/display-name
      render: (value) => <div>{value?.substring(0, 6).toUpperCase()}</div>,
    },
    {
      title: 'Status data',
      dataIndex: 'isProcessingData',
      key: 'isProcessingData',
      // eslint-disable-next-line react/display-name
      render: (value) => (
        <div>
          {value ? (
            <Tag icon={<SyncOutlined spin />} color="processing">
              Processing
            </Tag>
          ) : (
            <Tag icon={<CheckCircleOutlined />} color="success">
              Completed
            </Tag>
          )}
        </div>
      ),
    },
    {
      title: 'Pin',
      dataIndex: 'uid',
      key: 'pin',
      align: 'center',
      // eslint-disable-next-line react/display-name
      render: (value) => (
        <div>
          <span>
            <Tooltip title="Generate">
              <SecurityScanTwoTone
                className="detail-user-icon"
                style={{ fontSize: '22px' }}
                onClick={() => {
                  handleGetPin(value);
                }}
              />
            </Tooltip>
          </span>
        </div>
      ),
    },
    {
      title: 'Detail',
      dataIndex: 'uid',
      key: 'uid',
      align: 'center',
      // eslint-disable-next-line react/display-name
      render: (value, record) => (
        <div>
          <span>
            <Tooltip title="View">
              <Link
                to={
                  '/user-management/' +
                  value +
                  '?phoneNumber=' +
                  record.phoneNumber
                }
              >
                <EyeOutlined
                  className="detail-user-icon"
                  style={{ fontSize: '22px' }}
                />
              </Link>
            </Tooltip>
          </span>
        </div>
      ),
    },
  ];

  async function getUserList(params) {
    setLoading(true);
    const res = await getListUser(params);
    if (res) {
      let i = 0;

      res.users = res.users.map((e) => {
        ++i;
        e.key = i;
        e.lastSignInTime = e.metadata.lastSignInTime;
        e.createdAt = e.metadata.creationTime;
        return e;
      });

      if (res.pageToken) {
        setNextPageToken(res.pageToken);
        setTotalItem(params.limit * (current - 1) + res.users.length + 1);
      } else {
        setTotalItem(params.limit * (current - 1) + res.users.length);
      }

      setListUser(res);
    }

    setLoading(false);
  }

  async function onGetUserCount() {
    const res = await getUserCount();
    if (res) {
      setUserCount(res);
    }
  }

  // function handleClick(value) {
  //   setUserId(value);
  //   setIsShow(true);
  // }

  function handleChangePageSize(page) {
    if (page.pageSize !== params.limit) {
      setTotalItem(0);
      setCurrent(1);
      setParams((previousState) => ({
        ...previousState,
        limit: page.pageSize,
        pageToken: '',
      }));
    } else {
      let arr = pageTokens;
      let pageToken = nextPageToken;

      if (page.current === 1) {
        pageToken = '';
      } else {
        if (page.current > current) {
          setCurrent(page.current);
          arr.push(nextPageToken);
          setPageTokens(arr);
        } else if (page.current < current) {
          setCurrent(page.current);
          pageToken = arr.pop();
          pageToken = arr.pop();
          setPageTokens(arr);
        }
      }

      setParams((previousState) => ({
        ...previousState,
        pageToken: pageToken,
      }));
    }
  }

  // function handleCancel() {
  //   setIsShow(false);
  //   setUserId(null);
  // }

  function handleSearch(value) {
    if (value) {
      setParams((previousState) => ({
        ...previousState,
        phoneNumber: value,
        limit: '',
      }));
    } else {
      setParams((previousState) => ({
        ...previousState,
        phoneNumber: '',
      }));
    }
  }

  function handleRefresh() {
    setParams((previousState) => ({
      ...previousState,
      pageToken: '',
      phoneNumber: '',
    }));

    setPageTokens([]);
  }

  function handleGetPin(value) {
    setUserId(value);
    setIsShow(true);
  }

  function handleCancelModal() {
    setIsShow(false);
  }

  return (
    <>
      <ModalPin visible={isShow} userId={userId} onCancel={handleCancelModal} />
      <UserLayoutStyle>
        <CustomBreadcrumb routes={routes} />
        <Row gutter={[24, 24]}>
          <Col lg={8} md={8} sm={12} xs={24}>
            <StatisticCard
              type="TOTAL"
              number={userCount?.total}
              text="Total"
            />
          </Col>
          <Col md={8} sm={12} xs={24}>
            <StatisticCard
              type="SAMOAN"
              number={userCount?.samoan}
              text="Samoan"
            />
          </Col>
          <Col md={8} sm={12} xs={24}>
            <StatisticCard
              type="FOREIGNER"
              number={userCount?.foreigner}
              text="Foreigner"
            />
          </Col>
        </Row>
        <div className="table-input-group">
          <Search
            className="input-search-phone"
            placeholder="Search phone number"
            allowClear
            onSearch={handleSearch}
          />
          <Tooltip
            title="Refresh"
            // overlayStyle={{ color: 'black' }}
            // overlayClassName="custom-tooltip"
          >
            <Button
              className={`btn-refresh ${
                isLoading ? 'btn-refresh-disabled' : ''
              }`}
              type="primary"
              icon={<RedoOutlined />}
              size="large"
              onClick={handleRefresh}
              disabled={isLoading}
            />
          </Tooltip>
        </div>
        <Table
          // pagination={true}
          dataSource={listUser.users}
          columns={columns}
          loading={isLoading}
          onChange={handleChangePageSize}
          pagination={{
            pageSize: params && params.limit,
            total: totalItem,
            defaultPageSize: params && params.limit,
            defaultCurrent: params && params.page,
            showSizeChanger: true,
            showLessItems: true,
            pageSizeOptions: [2, 10, 20, 30, 40, 50],
          }}
        />
      </UserLayoutStyle>
    </>
  );
}

UserPage.propTypes = {};

export default UserPage;
